import {isAdmin, isAdminAsPartner, isPartner} from "./authUtils";

export const presetsAccessType = () =>
    (isPartner() || isAdminAsPartner())
        ? "PARTNER"
        : isAdmin
            ? "MANAGER" : null;